export const API_ENDPOINTS = {
    // BASE_URL: 'http://127.0.0.1:8000',
    // BASE_URL: 'http://3.7.1.236:8005',
    BASE_URL : 'https://my-company.info',
    // BASE_URL : 'https://devtest.my-company.info',
  
    // BASE_URL_MEDIA: 'http://127.0.0.1:8000/media',



   
    POST_login: '/api/login/', 

    // Dashboard
    POST_create_district : '/api/district/create/',
    PUT_update_district : '/api/district/update/',
    GET_district_count : '/api/district/count/',

    POST_create_region : '/api/region/create/',
    PUT_update_region : '/api/region/update/',

    POST_create_chapters : '/api/chapter/create/',
    PUT_update_chapter : '/api/chapter/update/',
    GET_all_chapters : '/api/chapter/get-all-chapters/',

    POST_create_member : '/api/member/create/',
    PUT_update_member : '/api/member/update-member/',
    GET_member : '/api/member/get-member-details/',
    POST_renew_member : '/api/member/renewal/add-member-renewals/',

    POST_business_category : '/api/business-category/create/',
    PUT_update_business_category : '/api/business-category/update/',
    GET_business_category : '/api/business-category/list/',
    GET_business_category_all_list : '/api/business-category/list_on_management_of_category/',
    DELETE_business_category : '/api/business-category/delete/',

    POST_create_event : '/api/event/create/',
    GET_event : '/api/event/get/',
    DELETE_event : '/api/event/delete/',
    GET_event_attendee : '/api/event/get-event-attendee/',

    GET_member_by_chapters : '/api/chapter/attendance/get/',
    POST_mark_chapter_attendance : '/api/chapter/meeting/attendance/mark/',
    
    GET_chapter_meetingsMom : '/api/chapter/meeting/get-chapter-meeting/',
    POST_meeting_add_or_update : '/api/chapter/meeting/add-or-update/',


    GET_self_registered_members: '/api/member/get-self-registered-members/',
    PUT_accept_self_registered_members: '/api/member/accept-self-registered-member/',
    PUT_reject_self_registered_members: '/api/member/reject-self-registered-member/',

    GET_district_summery: '/api/district/summary/',
    GET_region_summery: '/api/region/summary/',
    GET_chapter_summery: '/api/chapter/summary/',
    GET_member_summery: '/api/member/summary/',

    GET_member_count_by_chapters : '/api/member/count/',
    

    GET_cities: '/api/city/get/',

    POST_validate_admin_key: '/api/member-subscription/check-admin-key/',
    GET_secret_data: '/api/member-subscription/get-member-subscription_scr/',
    UPDATE_accept: '/api/member-subscription/update-member-subscription-accept/',


    GET_plans: '/api/plans/get-plans/',
    POST_create_plan: '/api/plans/create/',
    PUT_update_plan: '/api/plans/update-plan/',


  };  
  